import { stringify } from 'query-string';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import { sortOrderTypes } from 'types/shared';
import getCountryIds from 'helpers/getCountryIds';

interface IPlaylistTableURLArgs {
  countryIds?: string[];
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  entityIds: string[];
  limit?: number;
  nameFilter?: string;
  offset?: number;
  sortBy?: string;
  sortOrder?: sortOrderTypes;
  region?: string;
  isTopList?: boolean;
  isPriority?: boolean;
  ownerTypeIds?: number;
  customRegion?: string | string[];
  playlistType?: string;
}

export default function getPlaylistTableURL(
  args: IPlaylistTableURLArgs
): string {
  const {
    countryIds,
    customerFilter,
    download,
    entityIds,
    limit = 10,
    nameFilter,
    offset = 0,
    sortBy,
    sortOrder = 'desc',
    region,
    isTopList,
    isPriority,
    ownerTypeIds,
    customRegion,
    playlistType,
  } = args;

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    limit,
    nameFilter,
    expand: isTopList ? 'tracks_count' : 'none',
    offset,
    ...(!isTopList && { sortby: sortBy }),
    ...(!isTopList && { sortOrder }),
    regionBreakdown:
      region && !countryIds && !customRegion
        ? 'region'
        : isTopList
        ? 'none'
        : 'country',
    ownerTypeIds: ownerTypeIds ? ownerTypeIds : undefined,
    playlistType,
  });

  return `/api/playlist${
    isTopList ? '' : `${isPriority ? '/positions' : ''}/table/track/${entityIds}`
  }?${params}`;
}
